import {SEARCH_EVENTNAME, SEARCH_EVENTCREATOR} from '../actions/searchEventAction'


const initial_state = {
    searchTitle: '',
    searchCreator: ''
}



const searchEvent = (state = initial_state, action) => {
    
    switch (action.type) {
        case SEARCH_EVENTNAME: {
            return {
                searchTitle: action.data
            }
        }
        
        case SEARCH_EVENTCREATOR: {
            return {
                searchCreator: action.data
            }
        }
        default: return state;
    }
}

export default searchEvent